import { create } from 'zustand';

interface Portfolio {
  id: string;
  name: string;
  nominal_value: number;
  account_count: number;
  status: string;
  created_at: string;
}

interface PortfolioStore {
  portfolios: Portfolio[];
  selectedPortfolio: Portfolio | null;
  setPortfolios: (portfolios: Portfolio[]) => void;
  setSelectedPortfolio: (portfolio: Portfolio | null) => void;
  addPortfolio: (portfolio: Portfolio) => void;
  updatePortfolio: (id: string, updates: Partial<Portfolio>) => void;
}

export const usePortfolioStore = create<PortfolioStore>((set) => ({
  portfolios: [],
  selectedPortfolio: null,
  setPortfolios: (portfolios) => set({ portfolios }),
  setSelectedPortfolio: (portfolio) => set({ selectedPortfolio: portfolio }),
  addPortfolio: (portfolio) => set((state) => ({ 
    portfolios: [...state.portfolios, portfolio] 
  })),
  updatePortfolio: (id, updates) => set((state) => ({
    portfolios: state.portfolios.map(p => p.id === id ? { ...p, ...updates } : p),
    selectedPortfolio: state.selectedPortfolio?.id === id 
      ? { ...state.selectedPortfolio, ...updates } 
      : state.selectedPortfolio,
  })),
}));
